import { render, staticRenderFns } from "./EditNote.vue?vue&type=template&id=0be094f6&scoped=true&lang=html&"
import script from "./EditNote.vue?vue&type=script&lang=js&"
export * from "./EditNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be094f6",
  null
  
)

export default component.exports